import { render, staticRenderFns } from "./challenge.vue?vue&type=template&id=fdef50b8&scoped=true"
import script from "./challenge.vue?vue&type=script&lang=js"
export * from "./challenge.vue?vue&type=script&lang=js"
import style0 from "./challenge.vue?vue&type=style&index=0&id=fdef50b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdef50b8",
  null
  
)

export default component.exports